export const NO_PRINT_TAG = '印刷なし'
